module.exports = __webpack_public_path__ + "static/media/arrow-back.68490bfe.svg";